import React from "react";
import { MaybeSort, Sort, UserSortKey, UserTableSort } from "Shared/types/Sort";
import { DPButton } from "Components/DP";
import { TableCell } from "@material-ui/core";
import SortIcon from "Components/Pages/Users/UserTable/SortableHeaderCell/SortIcon";
import useStyles from "./styles";

type Props = {
  id: string;
  name: string;
  sort: UserTableSort;
  sortKey: UserSortKey;
  updateSort: (s: UserTableSort) => void;
};

const cycleSort: (sort: MaybeSort) => Sort = (sort: MaybeSort) => {
  return sort === "asc" ? "desc" : "asc";
};

const SortableHeaderCell = ({ id, name, sort, sortKey, updateSort }: Props) => {
  const thisColSort = sort[0] === sortKey ? sort[1] : null;
  const classes = useStyles({ sorted: !!thisColSort });

  return (
    <TableCell align="left" className={classes.cell}>
      <DPButton
        id={`${id}-header`}
        align="left"
        variant="text"
        className={classes.button}
        onClick={() => updateSort([sortKey, cycleSort(thisColSort)])}
      >
        {name}
        <SortIcon
          id={id}
          className={classes.buttonIcon}
          thisColSort={thisColSort}
        />
      </DPButton>
    </TableCell>
  );
};

export default SortableHeaderCell;
